import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'customer-contracts';

const updateContractById = async (body, contractId) => {
  const method = 'PUT';
  const url = `${USE_CASE_URL}/${contractId}`;

  const json = await request({ method, url, body });
  return json;
};

export default updateContractById;
